<template>
	<AppDialog :dialogName="'AskForIntegration'" closeRight="-172">
		<div class="pop-up-content-container dialog-boarders">
			<div data-canny />
		</div>
	</AppDialog>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { user } from '@/store/modules/auth/getters';
const BOARD_TOKEN = '163c274d-fc0b-f62a-fcae-6cda2273eda1';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
export default {
	name: 'AskForIntegrationPopUp',
	components: {
		AppDialog,
	},
	computed: {
		...mapGettersShorthand({ user }),
	},
	mounted() {
		(function (w, d, i, s) {
			function l() {
				if (!d.getElementById(i)) {
					var f = d.getElementsByTagName(s)[0],
						e = d.createElement(s);
					(e.type = 'text/javascript'), (e.async = !0), (e.src = 'https://canny.io/sdk.js'), f.parentNode.insertBefore(e, f);
				}
			}
			if ('function' != typeof w.Canny) {
				var c = function () {
					c.q.push(arguments);
				};
				(c.q = []),
					(w.Canny = c),
					'complete' === d.readyState ? l() : w.attachEvent ? w.attachEvent('onload', l) : w.addEventListener('load', l, !1);
			}
		})(window, document, 'canny-jssdk', 'script');

		// eslint-disable-next-line no-undef
		Canny('render', {
			boardToken: this.BOARD_TOKEN,
			basePath: null,
			ssoToken: this.user.canny_user_hash,
		});
	},
	data() {
		return {
			BOARD_TOKEN,
		};
	},
};
</script>

<style scoped lang="scss">
.dialog-boarders {
	border-radius: 15px;
	background-color: white;
	box-shadow: 0px 3px 6px var(--shadow-color);
}

.pop-up-content-container {
	padding: 50px;
	width: 1015px;
	height: 690px;
	overflow-y: auto;
	margin-left: -190px;
}
</style>
